import React, { useContext, useEffect, useState } from 'react';
import Pagination from "../components/Pagination";
import { ethers } from "ethers";
import Moment from 'react-moment';
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';
import { getUserNotifications } from '../../api/api';
// import { Link } from "@reach/router";
import { useNavigate, useParams,Link } from 'react-router-dom';
import {
  ThreeBounce
} from 'better-react-spinkit'
const GlobalStyles = createGlobalStyle`
header#myHeader .logo .d-block{
  display: none !important;
}
header#myHeader .logo .d-none{
  display: block !important;
}
.navbar .mainside a{
  background: #8364e2;
  &:hover{
    box-shadow: 2px 2px 20px 0px #8364e2;
  }
}
.item-dropdown{
  .dropdown{
    a{
      &:hover{
        background: #8364e2;
      }
    }
  }
}
.btn-main{
  background: #8364e2;
  &:hover{
    box-shadow: 2px 2px 20px 0px #8364e2;
  }
}
p.lead{
  color: #a2a2a2;
}
.navbar .navbar-item .lines{
  border-bottom: 2px solid #8364e2;
}
.jumbotron.no-bg{
  height: 100vh;
  overflow: hidden;
  background-repeat: repeat;
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;
}
#tsparticles{
  top: 0;
}
.text-uppercase.color{
  color: #8364e2;
}
.de_count h3 {
  font-size: 36px;
  margin-bottom: 0px;
}
.de_count h5{
  font-size: 14px;
  font-weight: 500;
}
h2 {
  font-size: 30px;
}
.box-url{
  text-align: center;
  h4{
    font-size: 16px;
  }
}
.de_countdown{
  border: solid 2px #8364e2;
}
.author_list_pp, .author_list_pp i, 
.nft_coll_pp i, .feature-box.style-3 i, 
footer.footer-light #form_subscribe #btn-subscribe i, 
#scroll-to-top div{
  background: #8364e2;
}
footer.footer-light .subfooter .social-icons span i{
  background: #403f83;
}
.author_list_pp:hover img{
  box-shadow: 0px 0px 0px 2px #8364e2;
}
.nft__item_action span{
  color: #8364e2;
}
.feature-box.style-3 i.wm{
  color: rgba(131,100,226, .1);
}
@media only screen and (max-width: 1199px) {
  .navbar{
    
  }
  .navbar .menu-line, .navbar .menu-line1, .navbar .menu-line2{
    background: #fff;
  }
  .item-dropdown .dropdown a{
    color: #fff !important;
  }
}
.profileBtn{
  width:150px;
  text-align: center;
  margin-top:5px;
}
.fsize32{
  font-size: 42px;
}
.text-left{
  text-align: left;
}
.exemplar_avatar {
  display: flex;
}
`;

const Notifications = function () {
  const [loading, setLoading] = useState(false);

  const [openMenu, setOpenMenu] = React.useState(true);
  const [openMenu1, setOpenMenu1] = React.useState(false);
  const [openMenu2, setOpenMenu2] = React.useState(false);
  const [openMenu3, setOpenMenu3] = React.useState(false);
  const [openMenu4, setOpenMenu4] = React.useState(false);
  const handleBtnClick = () => {
    setOpenMenu(!openMenu);
    setOpenMenu1(false);
    setOpenMenu2(false);
    setOpenMenu3(false);
    setOpenMenu4(false);
    document.getElementById("follow").classList.remove("active");
    document.getElementById("sale").classList.remove("active");
    document.getElementById("offer").classList.remove("active");
    document.getElementById("like").classList.remove("active");
  };
  const handleBtnClick1 = () => {
    setOpenMenu1(!openMenu1);
    setOpenMenu2(false);
    setOpenMenu(false);
    setOpenMenu3(false);
    setOpenMenu4(false);
    document.getElementById("follow").classList.add("active");
    document.getElementById("sale").classList.remove("active");
    document.getElementById("offer").classList.remove("active");
    document.getElementById("like").classList.remove("active");
  };
  const handleBtnClick2 = () => {
    setOpenMenu2(!openMenu2);
    setOpenMenu(false);
    setOpenMenu1(false);
    setOpenMenu3(false);
    setOpenMenu4(false);
    document.getElementById("follow").classList.remove("active");
    document.getElementById("sale").classList.add("active");
    document.getElementById("offer").classList.remove("active");
    document.getElementById("like").classList.remove("active");
  };
  const handleBtnClick3 = () => {
    setOpenMenu3(!openMenu3);
    setOpenMenu(false);
    setOpenMenu1(false);
    setOpenMenu2(false);
    setOpenMenu4(false);
    document.getElementById("follow").classList.remove("active");
    document.getElementById("sale").classList.remove("active");
    document.getElementById("offer").classList.remove("active");
    document.getElementById("like").classList.add("active");
  };
  const handleBtnClick4 = () => {
    setOpenMenu4(!openMenu4);
    setOpenMenu(false);
    setOpenMenu1(false);
    setOpenMenu3(false);
    setOpenMenu2(false);
    document.getElementById("follow").classList.remove("active");
    document.getElementById("sale").classList.remove("active");
    document.getElementById("offer").classList.add("active");
    document.getElementById("like").classList.remove("active");
  };

  ///////////////
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [items, setItems] = useState([]);
  const getItems = async () => {
    setLoading(true);
    let res = await getUserNotifications(currentPage);
    setItems(res.data);
    setTotalRecords(res.totalRecords)
    setLoading(false);
  }


  useEffect(() => {
    getItems();

  }, [currentPage])
  const onPageChange = async (page) => {
    setCurrentPage(page)
  }
  ///////////////
  const shortener = (txt) => {
    return txt.toString().substring(0, 8) + "..." + txt.toString().substring(txt.toString().length - 6)
  }
  ////////////////////////////////////////////////////////////////

  const notyFormat = (item) => {
    let f;
    switch (item.type) {
      case "LUCENT_NFT_MINT":
        // img,title,lucentNFT,
        return (
          <li className="act_sale" key={item.id}>
            <img className="lazy" src={item.img} alt="" />
            <div className="act_list_text">
              <h4>{item.title}</h4>
              <span className="fontsize12 bolder">LUCENT NFT</span>&nbsp;
              <span className="color"><Link className=' color axnoline fontsize12 bolder' to={"/lucent/" + item.lucentNFT}>#{item.lucentNFT}</Link></span>&nbsp;
              <span className="fontsize12 bolder">Your Lucent successfully minted!</span>
              {/* <span className='color'>Franklin Greer</span> offered 0.002 ETH {item.type} */}
              <span className="act_list_date fontsize14">
                {item.createdAt && <Moment format="HH:mm MMMM DD, YYYY">
                  {item.createdAt}
                </Moment>}
              </span>
            </div>
          </li>
        )
      case "MARKETPLACE_NFT_SELL":
        return (
          <li className="act_sale" key={item.id}>
            <img className="lazy" src={item.img} alt="" />
            <div className="act_list_text">
              <h4>{item.title}</h4>
              <span className="fontsize12 bolder">LUCENT NFT</span>&nbsp;
              <span className="color"><Link className=' color axnoline fontsize12 bolder' to={"/lucent/" + item.lucentNFT}>#{item.lucentNFT}</Link></span>&nbsp;
              <span className="fontsize12 bolder">Congratulations, Your Lucent sold!</span>
              {/* <span className='color'>Franklin Greer</span> offered 0.002 ETH {item.type} */}
              <span className="act_list_date fontsize14">
                {item.createdAt && <Moment format="HH:mm MMMM DD, YYYY">
                  {item.createdAt}
                </Moment>}
              </span>
            </div>
          </li>
        )
      case "MARKETPLACE_NFT_OWNER":
        return (
          <li className="act_sale" key={item.id}>
            <img className="lazy" src={item.img} alt="" />
            <div className="act_list_text">
              <h4>{item.title}</h4>
              <span className="fontsize12 bolder">LUCENT NFT</span>&nbsp;
              <span className="color"><Link className=' color axnoline fontsize12 bolder' to={"/lucent/" + item.lucentNFT}>#{item.lucentNFT}</Link></span>&nbsp;
              <span className="fontsize12 bolder">Congratulations, You bought this Lucent!</span>
              {/* <span className='color'>Franklin Greer</span> offered 0.002 ETH {item.type} */}
              <span className="act_list_date fontsize14">
                {item.createdAt && <Moment format="HH:mm MMMM DD, YYYY">
                  {item.createdAt}
                </Moment>}
              </span>
            </div>
          </li>
        )
      case "AUTOGRAPH_REQUEST":
        return (
          <li className="act_sale" key={item.id}>
            <img className="lazy" src={item.img} alt="" />
            <div className="act_list_text">
              <h4>{item.title}</h4>
              <span className="fontsize12 bolder">LUCENT NFT</span>&nbsp;
              <span className="color"><Link className=' color axnoline fontsize12 bolder' to={"/lucent/" + item.lucentNFT}>#{item.lucentNFT}</Link></span>&nbsp;
              <span className="fontsize12 bolder">You have an autograph request!</span>&nbsp;
              <span className="color"><Link className=' color axnoline fontsize12 bolder' to={"/autograph/requests"}>See Requests</Link></span>
              {/* <span className='color'>Franklin Greer</span> offered 0.002 ETH {item.type} */}
              <span className="act_list_date fontsize14">
                {item.createdAt && <Moment format="HH:mm MMMM DD, YYYY">
                  {item.createdAt}
                </Moment>}
              </span>
            </div>
          </li>
        )
      case "AUTOGRAPH_ACCEPT":
        return (
          <li className="act_sale" key={item.id}>
            <img className="lazy" src={item.img} alt="" />
            <div className="act_list_text">
              <h4>{item.title}</h4>
              <span className="fontsize12 bolder">LUCENT NFT</span>&nbsp;
              <span className="color"><Link className=' color axnoline fontsize12 bolder' to={"/lucent/" + item.lucentNFT}>#{item.lucentNFT}</Link></span>&nbsp;
              <span className="fontsize12 bolder">Congratulations, Your autograph request accepted!</span>
              {/* <span className='color'>Franklin Greer</span> offered 0.002 ETH {item.type} */}
              <span className="act_list_date fontsize14">
                {item.createdAt && <Moment format="HH:mm MMMM DD, YYYY">
                  {item.createdAt}
                </Moment>}
              </span>
            </div>
          </li>
        )


    }





    return f;
  }
  return (
    <div>
      <GlobalStyles />

      <section className=' breadcumb no-bg'>
        <div className='mainbreadcumb'>
          <div className='container'>
            <div className='row m-10-hor'>
              <div className='col-12'>
                <h1 className='text-center'>Notifications</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='container'>
       {!loading&& <ul className="activity-list">
          {items && items.map((item, index) => {
            return (
              notyFormat(item)
            )
          })}

        </ul>}
        {loading && <center><ThreeBounce size={14} color='#6f42c1' /><span className="col-purple loadertxt"></span></center>}
        {
          !loading && items && items.length === 0 && <div className="text-center">
            No results found.
          </div>
        }
        {/* <div className='row'>
    <div className="col-md-12">
          
          <ul className="activity-filter ">
              <li id='sale' className="filter_by_sales" onClick={handleBtnClick2}><i className="fa fa-shopping-basket"></i>Sales</li>
              <li id='like' className="filter_by_likes" onClick={handleBtnClick3}><i className="fa fa-heart"></i>Likes</li>
              <li id='offer' className="filter_by_offers" onClick={handleBtnClick4}><i className="fa fa-gavel"></i>Offers</li>
              <li id='follow' className="filter_by_followings" onClick={handleBtnClick1}><i className="fa fa-check"></i>Followings</li>
              
          </ul>
      </div>
      <div className="spacer-single"></div>
    <div className="col-md-12">

    {openMenu && (  
    <ul className="activity-list">
      <li className="act_follow">
          <img className="lazy" src="./img/author/author-1.jpg" alt=""/>
          <div className="act_list_text">
              <h4>Monica Lucas</h4>
              started following <span className='color'>Gayle Hicks</span>
              <span className="act_list_date">
                  10/07/2021, 12:40
              </span>
          </div>
      </li>
      <li className="act_sale">
          <img className="lazy" src="./img/items/thumbnail-2.jpg" alt=""/>
          <div className="act_list_text">
              <h4>Deep Sea Phantasy</h4>
             1 edition purchased by <span className='color'>Stacy Long</span>
              <span className="act_list_date">
                  10/07/2021, 12:40
              </span>
          </div>
      </li>
      <li className="act_follow">
          <img className="lazy" src="./img/author/author-2.jpg" alt=""/>
          <div className="act_list_text">
              <h4>Mamie Barnett</h4>
              started following <span className='color'>Claude Banks</span>
              <span className="act_list_date">
                  10/07/2021, 12:40
              </span>
          </div>
      </li>
      <li className="act_sale">
          <img className="lazy" src="./img/items/thumbnail-4.jpg" alt=""/>
          <div className="act_list_text">
              <h4>Two Tigers</h4>
             1 edition purchased by <span className='color'>Jimmy Wright</span> for 0.02 ETH 
              <span className="act_list_date">
                  10/07/2021, 12:40
              </span>
          </div>
      </li>
      <li className="act_like">
          <img className="lazy" src="./img/items/thumbnail-7.jpg" alt=""/>
          <div className="act_list_text">
              <h4>Cute Astronout</h4>
             liked by <span className='color'>Nicholas Daniels</span>
              <span className="act_list_date">
                  10/07/2021, 12:40
              </span>
          </div>
      </li>
      <li className="act_sale">
          <img className="lazy" src="./img/items/thumbnail-5.jpg" alt=""/>
          <div className="act_list_text">
              <h4>Purple Planet</h4>
             <span className='color'>Franklin Greer</span> offered 0.002 ETH
              <span className="act_list_date">
                  10/07/2021, 12:40
              </span>
          </div>
      </li>
      <li className="act_like">
          <img className="lazy" src="./img/items/thumbnail-6.jpg" alt=""/>
          <div className="act_list_text">
              <h4>Cute Astronout</h4>
             liked by <span className='color'>Nicholas Daniels</span>
              <span className="act_list_date">
                  10/07/2021, 12:40
              </span>
          </div>
      </li>
    </ul>
    )}

    {openMenu1 && (  
    <ul className="activity-list">
      <li className="act_follow">
          <img className="lazy" src="./img/author/author-1.jpg" alt=""/>
          <div className="act_list_text">
              <h4>Monica Lucas</h4>
              started following <span className='color'>Gayle Hicks</span>
              <span className="act_list_date">
                  10/07/2021, 12:40
              </span>
          </div>
      </li>
      <li className="act_follow">
          <img className="lazy" src="./img/author/author-2.jpg" alt=""/>
          <div className="act_list_text">
              <h4>Mamie Barnett</h4>
              started following <span className='color'>Claude Banks</span>
              <span className="act_list_date">
                  10/07/2021, 12:40
              </span>
          </div>
      </li>
    </ul>
    )}

    {openMenu2 && (  
    <ul className="activity-list">
      <li className="act_sale">
          <img className="lazy" src="./img/items/thumbnail-2.jpg" alt=""/>
          <div className="act_list_text">
              <h4>Deep Sea Phantasy</h4>
             1 edition purchased by <span className='color'>Stacy Long</span>
              <span className="act_list_date">
                  10/07/2021, 12:40
              </span>
          </div>
      </li>
      <li className="act_sale">
          <img className="lazy" src="./img/items/thumbnail-4.jpg" alt=""/>
          <div className="act_list_text">
              <h4>Two Tigers</h4>
             1 edition purchased by <span className='color'>Jimmy Wright</span> for 0.02 ETH 
              <span className="act_list_date">
                  10/07/2021, 12:40
              </span>
          </div>
      </li>
    </ul>
    )}

    {openMenu3 && ( 
      <ul className="activity-list">
        <li className="act_like">
            <img className="lazy" src="./img/items/thumbnail-7.jpg" alt=""/>
            <div className="act_list_text">
                <h4>Cute Astronout</h4>
               liked by <span className='color'>Nicholas Daniels</span>
                <span className="act_list_date">
                    10/07/2021, 12:40
                </span>
            </div>
        </li>
        <li className="act_like">
          <img className="lazy" src="./img/items/thumbnail-6.jpg" alt=""/>
          <div className="act_list_text">
              <h4>Cute Astronout</h4>
             liked by <span className='color'>Nicholas Daniels</span>
              <span className="act_list_date">
                  10/07/2021, 12:40
              </span>
          </div>
      </li>
      </ul>
    )}

    {openMenu4 && ( 
      <ul className="activity-list">
        <li className="act_sale">
            <img className="lazy" src="./img/items/thumbnail-5.jpg" alt=""/>
            <div className="act_list_text">
                <h4>Purple Planet</h4>
               <span className='color'>Franklin Greer</span> offered 0.002 ETH
                <span className="act_list_date">
                    10/07/2021, 12:40
                </span>
            </div>
        </li>
      </ul>
    )}
    </div>
    

  
    </div> */}
      </section>
      <section className="container no-top">
        <div ><Pagination onPageChange={onPageChange} _currentPage={currentPage} recordsPerPage={10} pageNumberLimit={5} totalRecords={totalRecords} /></div>
      </section>
      <Footer />
    </div>

  );
}

export default Notifications;